import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import Button from "../ui/Button";
import Modal from "../modal/Modal";
import { clearAuthCookies } from "@utils/cookies";
import { useRoleTest } from "../RoleTestContext";

export default function LogoutButton({ children = "Logout", ...props }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [showConfirm, setShowConfirm] = useState(false);
  const { setTestRoleId } = useRoleTest();

  function handleLogout() {
    setTestRoleId(null);
    clearAuthCookies();
    queryClient.clear();
    navigate("/login", { replace: true });
  }

  return (
    <>
      <Button variant="outline" onClick={() => setShowConfirm(true)} {...props}>
        {children}
      </Button>

      <Modal
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        title="Confirm Logout"
        size="sm"
        showCloseButton={false}
      >
        <p className="text-sm text-palette-gray-badge mb-6">Are you sure you want to log out?</p>
        <div className="flex items-center justify-end gap-3">
          <Button variant="outline" size="sm" onClick={() => setShowConfirm(false)}>
            Cancel
          </Button>
          <Button variant="danger" size="sm" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </Modal>
    </>
  );
}
